import { SHOW_ALERT, HIDE_ALERT } from "../actionTypes"

export const showAlert = (msg, isError) => ({
  type: SHOW_ALERT,
  payload: {
    message: msg,
    alertType: isError ? 'error': 'success'
  }
})

export const hideAlert = msg => ({
  type: HIDE_ALERT,
  payload: {
    message: '',
    alertType: ''
  }
})



// WEBPACK FOOTER //
// ./src/store/actions/alert.js